import Vue from "vue";

export type TaskMethod<T> = () => Promise<T>;

export default Vue.extend({
    data() {
        return {
            isInProgress: false,
        };
    },
    methods: {
        task<T>(task: TaskMethod<T>): Promise<T> {
            this.isInProgress = true;

            return task()
                .finally(() => {
                    this.isInProgress = false;
                });
        },
    },
});